/**
 * Shown for slide types whose web activity is not implemented yet. Lets the
 * player keep navigating and shows what the slide contains, for QA.
 */
import type { Slide } from "@makeit/schema";
import { usePlayer } from "../context";
import { t } from "../i18n";

export function PlaceholderSlide({ slide }: { slide: Slide }) {
  const { finish } = usePlayer();
  const summary = Object.entries(slide)
    .filter(([k, v]) => Array.isArray(v) && k !== "freeElements")
    .map(([k, v]) => `${k}: ${(v as unknown[]).length}`)
    .join(" · ");
  return (
    <div className="placeholder">
      <div className="placeholder-type">{slide.type}</div>
      <div className="placeholder-summary">{summary || "—"}</div>
      <div className="placeholder-note">Aquest tipus d'activitat no està disponible</div>
      <button className="btn" onClick={() => finish({ correct: true, points: 0, stars: 3 })}>
        {t("continue")}
      </button>
    </div>
  );
}
